import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  text-align: center;
`;

export const DatesContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
